import { post } from "./ajax";
import notificationToast from "./notification-toast.js";

export default class LSSettings {
    constructor() {
        this.submitButton = null;
        this.init();
        this.setupValidationRules();
        this.ManageEPGModuleSection();
        this.initializeExistingAds();
    }

    // Add this new method
    initializeExistingAds() {
        // Initialize all existing ad blocks when the page loads
        jQuery('.ls-ad-block-mid_roll').each((index, element) => {
            this.initializeAdFields(jQuery(element));
        });
    }

    init() {
        jQuery(document.body)
            .on("submit", "#ls_admin_settings_form", this.saveSettings.bind(this))
            .on('change', '.ls-epg-enable-disable', this.toggleEPGSettingsFields.bind(this))
            .on("change", 'input[name="ls_adds_enable_disable"]', this.handleGlobalAdsToggle.bind(this))
            .on("change", 'select[name="global_ads_type"]', this.handleAdsTypeChange.bind(this))
            .on("change", 'input[name="global_pre_roll_enabled"]', this.handlePreRollToggle.bind(this))
            .on("change", 'input[name="global_mid_roll_enabled"]', this.handleMidRollToggle.bind(this))
            .on("change", 'input[name="global_post_roll_enabled"]', this.handlePostRollToggle.bind(this))
            .on("click", "#generate_mid_roll_ads_settings_section", this.addNewMidRollAd.bind(this))
            .on("click", ".ls-clear-color", this.clearSelectedColor.bind(this))
            .on("change", 'select[name$="[global_structure_type]"]', this.handleAdStructureChange.bind(this))
            .on("change", '.enable-skip-toggle-radio', this.handleSkipToggle.bind(this))
            .on("change", 'input[name="global_pre_roll_skippable"], input[name="global_post_roll_skippable"]', this.handleSkipToggle.bind(this))
            .on("click", ".ls-delete-ad", this.deleteAd.bind(this));


    }

    handleGlobalAdsToggle(event) {
        jQuery('#adds_display').toggleClass('hidden', event.target.value !== 'enable');
    }

    handleAdsTypeChange(event) {
        const selectedType = event.target.value;
        // Updated selector to match new structure
        jQuery('#adds_type_vast')[selectedType === 'vast' ? 'removeClass' : 'addClass']('hidden');
        jQuery('#adds_type_html')[selectedType === 'html' ? 'removeClass' : 'addClass']('hidden');
    }

    handlePreRollToggle(event) {
        const isEnabled = event.target.value === 'enable';
        jQuery('.pre_roll_add_data').toggleClass('hidden', !isEnabled);
    }

    handleMidRollToggle(event) {
        const isEnabled = event.target.value === 'enable';
        jQuery('.mid_roll_add_data').toggleClass('hidden', !isEnabled);

        // Initialize first ad if enabling and no ads exist
        if (isEnabled && jQuery('.mid-roll-ads-list').children().length === 0) {
            this.addNewMidRollAd();
        }
    }

    handlePostRollToggle(event) {
        const isEnabled = event.target.value === 'enable';
        jQuery('.post_roll_add_data').toggleClass('hidden', !isEnabled);
    }

    handleSkipToggle(event) {
        const radio = jQuery(event.target);
        const adBlock = radio.closest('.pre_roll_add_data, .post_roll_add_data, .midroll_skip_enable_section');
        const skipDelayField = adBlock.find('input[name$="global_pre_roll_skip_delay"], input[name$="global_post_roll_skip_delay"], input[id$="global_mid_roll_skip_delay"]').closest('.ls-field-wrap');
        skipDelayField.toggleClass('hidden', radio.val() === 'no'); // Show field when 'yes' is selected
    }

    async addNewMidRollAd(event) {
        if (event) {
            event.preventDefault();
        }

        try {
            const adsList = jQuery('.mid-roll-ads-list');
            const counter = adsList.children().length;

            const response = await post('add_html_add_structure', {
                structure_id: counter,
                method: 'mid_roll',
                location: 'settings'
            });

            if (response.success && response.data) {
                const newAd = jQuery(response.data);
                adsList.append(newAd);
                var newRelValue = newAd.attr('rel');
                const urlFields = [
                    {
                        name: `global_mid_roll_ads[${newRelValue}][global_duration]`, rule: {
                            number: true,
                            min: 0
                        }
                    },
                    {
                        name: `global_mid_roll_ads[${newRelValue}][global_adds_url]`, rule: {
                            required: function () {
                                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_${newRelValue}`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
                            },
                            url: function () {
                                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_${newRelValue}`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
                            },
                        }
                    },
                    {
                        name: `global_mid_roll_ads[${newRelValue}][global_title]`, rule: {
                            required: function () {
                                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_${newRelValue}`).val() !== 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
                            }
                        }
                    },
                    {
                        name: `global_mid_roll_ads[${newRelValue}][global_logo_url]`, rule: {
                            imageUrl: function () {
                                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_${newRelValue}`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
                            },
                            url: function () {
                                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_${newRelValue}`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
                            }
                        }
                    },
                    {
                        name: `global_mid_roll_ads[${newRelValue}][global_cta_url]`, rule: {
                            url: function () {
                                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_${newRelValue}`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
                            }
                        }
                    }
                ];
                
                urlFields.forEach(field => {
                    this.addDynamicValidationRule(field.name, field.rule, '#ls_admin_settings_form');
                });

                // Initialize the new ad block
                this.initializeAdFields(newAd);


                // Ensure it starts collapsed
                newAd.find('.ls-metabox').addClass('closed');
                newAd.find('.ls_advertisement_data').hide();

            }
        } catch (error) {
            console.error('Error adding new mid-roll ad:', error);
        }
    }

    // Add these helper methods to your class
    addDynamicValidationRule(fieldName, rule, formSelector) {
        // Store dynamic rules for later use
        if (!this.dynamicRules) {
            this.dynamicRules = {};
        }
        this.dynamicRules[fieldName] = rule;

        // Apply the rule to existing validator if it exists
        const validator = jQuery(formSelector).data('validator');

        if (validator) {
            validator.settings.rules[fieldName] = rule;
        }
    }

    addDynamicValidationMessage(fieldName, message, formSelector) {
        // Store dynamic messages for later use
        if (!this.dynamicMessages) {
            this.dynamicMessages = {};
        }
        this.dynamicMessages[fieldName] = message;

        // Apply the message to existing validator if it exists
        const validator = jQuery(formSelector).data('validator');
        if (validator) {
            validator.settings.messages[fieldName] = message;
        }
    }

    initializeAdFields(adBlock) {
        // Show relevant fields
        const structureSelect = adBlock.find('.ls_add_strture_select');
        const commonFields = adBlock.find('.common_adds_fields');

        structureSelect.show();
        commonFields.removeClass('hidden');

        // Initialize color picker if available
        if (typeof jQuery.fn.wpColorPicker === 'function') {
            const colorPickers = adBlock.find('input[type="color"]');
            colorPickers.wpColorPicker();
        }

        // Initialize structure type visibility
        this.handleAdStructureChange({
            target: adBlock.find('select[name$="[global_structure_type]"]')[0]
        });

        // Ensure form state is properly managed
        adBlock.find('input, select, textarea').on('change', function () {
            // Mark form as having unsaved changes
            jQuery('#ls_admin_settings_form').data('hasChanges', true);
        });
    }

    handleAdStructureChange(event) {

        const select = jQuery(event.target);
        const adBlock = select.closest('.ls-ad-block-mid_roll');
        const selectedValue = select.val();

        if (adBlock.length) {
            const videoSection = adBlock.find('.adds_video_url_section');
            const commonFields = adBlock.find('.common_adds_fields');

            if (selectedValue === 'full_screen') {
                videoSection.removeClass('hidden');
                commonFields.addClass('hidden');
            } else {
                videoSection.addClass('hidden');
                commonFields.removeClass('hidden');
            }
        }
    }

    saveSettings(event) {

        event.preventDefault();

        const form = event.target;
        this.submitButton = form.querySelector('input[type="submit"]');
        if (this.submitButton) {
            this.submitButton.type = 'button';
        }
        const formData = new FormData(form);
        const data     = {};

        // Properly handle array-like form fields
        formData.forEach((value, key) => {
            if (key.includes('[') && key.includes(']')) {
                const matches = key.match(/^([^\[]+)\[(\d+)\]\[([^\]]+)\]$/);
                if (matches) {
                    const [, arrayName, index, fieldName] = matches;

                    const normalizedArrayName = arrayName === 'mid_roll_ads' ? 'global_mid_roll_ads' : arrayName;

                    if (!data[normalizedArrayName]) {
                        data[normalizedArrayName] = [];
                    }
                    if (!data[normalizedArrayName][index]) {
                        data[normalizedArrayName][index] = {};
                    }
                    data[normalizedArrayName][index][fieldName] = value;
                } else {
                    data[key] = value;
                }
            } else {
                data[key] = value;
            }
        });

        // Ensure mid-roll ads array maintains sequential indexes
        if (data.global_mid_roll_ads) {
            data.global_mid_roll_ads = Object.values(data.global_mid_roll_ads).filter(Boolean);
        }

        const currentFrom = jQuery(event.currentTarget);
        const validator = currentFrom.validate();
        if (currentFrom.valid()) {
            this.updateSettings(data);

        } else {
            this.submitButton.type = 'submit';
            notificationToast.error(LSAjax.errorMessages.error_common, 'Error');
        }

    }

    getValidationMessages(messages) {
        // Add messages for new rules
        messages.vast_url = {
            required: LSAjax.errorMessages.vast_url,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages.mid_roll_adds_time = {
            number: LSAjax.errorMessages.mid_roll_adds_time_number,
            min: LSAjax.errorMessages.mid_roll_adds_time_min
        }

        messages['mid_roll_ads[0][adds_url]'] = {
            required: LSAjax.errorMessages.adds_url_required,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages['pre_role_add[0][adds_url]'] = {
            required: LSAjax.errorMessages.adds_url_required,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages['mid_roll_ads[0][adds_branding_url]'] = {
            url: LSAjax.errorMessages.adds_url_required
        }

        messages['mid_roll_ads[0][adds_cta_url]'] = {
            url: LSAjax.errorMessages.adds_url_required
        }
        return messages;
    }

    getValidationRules(rules) {
        // Custom validator method for image URL extensions
        jQuery.validator.addMethod("imageUrl", function (value, element) {
            if (this.optional(element)) {
                return true; // Skip if the field is optional
            }

            try {
                const url = new URL(value); // Parse the URL
                const pathname = url.pathname.toLowerCase();

                const imageExtensions = LSAjax.allow_image_type || ['jpg', 'jpeg', 'png', 'gif', 'webp'];

                return imageExtensions.some(ext => pathname.endsWith(`.${ext.toLowerCase()}`));
            } catch (e) {
                return false; // Invalid URL structure
            }
        }, LSAjax.errorMessages.error_invalid_image_url);

        // Add new validation rules
        rules.vast_url = {
            required: function () {
                return jQuery('#global_ads_type').val() == 'vast' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable';
            },
            url: function () {
                return jQuery('#global_ads_type').val() == 'vast' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable';
            },
        };

        rules.global_pre_roll_url = {
            required: function () {
                return jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable' && jQuery('input[name="global_pre_roll_enabled"]:checked').val() === 'enable';
            },
            url: function () {
                return jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable' && jQuery('input[name="global_pre_roll_enabled"]:checked').val() === 'enable';
            },
        }

        rules.global_mid_roll_adds_time = {
            number: true,
            min: 0
        };


        rules["global_mid_roll_ads[0][global_duration]"] = {
            number: true,
            min: 0
        }

        rules['global_mid_roll_ads[0][global_adds_url]'] = {
            required: function () {
                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            },
            url: function () {
                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            },
        };

        rules['global_mid_roll_ads[0][global_title]'] = {
            required: function () {
                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_0`).val() !== 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            }
        }
        rules['global_mid_roll_ads[0][global_logo_url]'] = {
            imageUrl: function () {
                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_0`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            },
            url: function () {
                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_0`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            }
        }
        rules['global_mid_roll_ads[0][global_cta_url]'] = {
            url: function () {
                return jQuery('#global_ads_type').val() == 'html' && jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable' && jQuery(`#global_structure_type_mid_roll_0`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            }
        }

        // Function to generate rules for a specific index
        const getMidRollRules = (index) => {

            // Common condition for all mid-roll ad validations
            const isMidRollValid = () => {
                return jQuery('#global_ads_type').val() == 'html' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                    jQuery('input[name="global_mid_roll_enabled"]:checked').val() == 'enable';
            };

            return {
                [`global_mid_roll_ads[${index}][global_adds_url]`]: {
                    required: function () {
                        return isMidRollValid() &&
                            jQuery(`#global_structure_type_mid_roll_${index}`).val() == 'full_screen';
                    },
                    url: function () {
                        return isMidRollValid() &&
                            jQuery(`#global_structure_type_mid_roll_${index}`).val() == 'full_screen';
                    }
                },
                [`global_mid_roll_ads[${index}][global_title]`]: {
                    required: function () {
                        return isMidRollValid() &&
                            jQuery(`#global_structure_type_mid_roll_${index}`).val() !== 'full_screen';
                    }
                },
                [`global_mid_roll_ads[${index}][global_logo_url]`]: {
                    imageUrl: function () {
                        return isMidRollValid() &&
                            jQuery(`#global_structure_type_mid_roll_${index}`).val() === 'companion';
                    },
                    url: function () {
                        return isMidRollValid() &&
                            jQuery(`#global_structure_type_mid_roll_${index}`).val() === 'companion';
                    }
                },
                [`global_mid_roll_ads[${index}][global_cta_url]`]: {
                    url: function () {
                        return isMidRollValid() &&
                            jQuery(`#global_structure_type_mid_roll_${index}`).val() === 'companion';
                    }
                }
            };
        };

        // Add rules for all existing mid-roll ads on page load
        jQuery('.ls_html_mid_roll_adds').each(function () {
            const index = jQuery(this).attr('rel');

            if (index !== undefined && !isNaN(index)) {
                const midRollRules = getMidRollRules(index);
                jQuery.extend(rules, midRollRules);
            }
        });

        return rules;
    }

    updateSettings(data) {
        post('ls_update_admin_settigns', data)
            .then(response => {
                if (response.success) {
                    notificationToast.success(response.data.message, 'Success');
                    setTimeout(() => {
                        location.reload();
                    }, 2000);
                } else {
                    notificationToast.error(response.data.message, 'Error');
                    this.submitButton.type = 'submit';
                }
            })
            .catch(error => {
                console.error(error);
                notificationToast.error('An unexpected error occurred. Please try again.', 'Error');
                this.submitButton.type = 'submit';
            });
    }

    ManageEPGModuleSection() {
        this.toggleEPGSettingsFields(jQuery('.ls-epg-enable-disable:checked').val());
    }

    toggleEPGSettingsFields(event) {
        const value = event && event.target ? jQuery(event.target).val() : event;

        const addsElement = jQuery('.ls-epg-setting-fields');

        if (value === 'enable') {
            addsElement.removeClass('hidden').hide().fadeIn(300);;
        } else {
            addsElement.addClass('hidden');
        }
    }

    setupValidationRules() {
        let baseRules = {
            ls_epg_api_url: {
                url: function () {
                    return jQuery('input[name="ls_epg_enabled"]:checked').val() == 'enable'
                },
                required: function () {
                    return jQuery('input[name="ls_epg_enabled"]:checked').val() == 'enable'
                },
            },
            ls_epg_update_interval: {
                required: true,
                digits: true,
                min: 1,
            },
            ls_epg_cache_duration: {
                required: true,
                digits: true,
                min: 1,
            },
            ls_epg_timezone: {
                required: true,
            },
        };

        let baseMessages = {
            ls_epg_api_url: {
                required: LSAjax.errorMessages.error_epg_url,
                url: LSAjax.errorMessages.error_epg_invalid_url,
            },
            ls_epg_update_interval: {
                required: LSAjax.errorMessages.error_epg_update_interval,
                digits: LSAjax.errorMessages.error_epg_update_interval_digits,
                min: LSAjax.errorMessages.error_epg_update_interval_min,
            },
            ls_epg_cache_duration: {
                required: LSAjax.errorMessages.error_cache_duration,
                digits: LSAjax.errorMessages.error_cache_duration_digits,
                min: LSAjax.errorMessages.error_cache_duration_min,
            },
            ls_epg_timezone: {
                required: LSAjax.errorMessages.error_epg_timezone,
            },
        };

        // Allow other plugins to extend validation
        baseRules    = wp.hooks.applyFilters('ls_epg_setting_form_validation_rules', baseRules);
        baseMessages = wp.hooks.applyFilters('ls_epg_setting_form_validation_messages', baseMessages);


        jQuery('#ls_admin_settings_form').validate({
            ignore:         [],
            onsubmit:       false,
            errorClass:     "error-msg",
            errorElement:   "p",
            rules:          this.getValidationRules(baseRules),
            messages:       this.getValidationMessages(baseMessages),
            errorPlacement: function (error, element) {
                element.closest('.form-field').append(error);
            },
            invalidHandler: (event, validator) => {
                // This function is called when form is invalid
                this.handleValidationErrors(validator);
            }
        })
    }

    // Function to handle validation errors
    handleValidationErrors(validator) {

        jQuery('.ls-validation-error-message').each(function () {
            jQuery(this).find('span.error-msg').remove();
        });

        // Add error indicators for current errors
        validator?.errorList?.forEach(function (error) {
            const adsElement    = jQuery(error.element).closest('.ls-validation-error');
            var validationError = adsElement.find('.ls-validation-error-message');

            if (validationError.length > 0) {
                // Check if error span doesn't already exist
                if (validationError.find('> span.tab-error').length === 0 && validationError.find('.error-msg').length === 0) {
                    validationError.find('.title-text').append('<span class="error-msg"> Error</span>');
                }
            }
        });
    }

    clearSelectedColor(event) {
        event.preventDefault();
        const inputId = jQuery(event.currentTarget).data("target");
        const $input  = jQuery("#" + inputId);

        if ($input.length && $input.attr("type") === "color") {
            const defaultColor = $input.data("default");
            if (defaultColor) {
                // Set to default color
                $input.val(defaultColor);
                $input.attr("data-user-selected", "false");
            } else {
                // No default, clear the value
                $input.val("");
            }

            $input.trigger("change");
        }
    }

    deleteAd(event) {
        event.preventDefault();
        // Ask for user confirmation before deleting
        const confirmed = confirm(LSAjax.advetisment_delete_confirmation);
        if (confirmed) {
            const adBlock = jQuery(event.target).closest('.ls_html_mid_roll_adds');
            adBlock.remove();
        }
    }

}